
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-linear-progress",
      function () {
        return require("private-next-pages/joy-ui/react-linear-progress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-linear-progress"])
      });
    }
  